import React, { useEffect, useState, useMemo } from 'react';
import { Box, Button, Flex, Heading } from '@chakra-ui/react';

import Table from 'components/Table';
import { useStores } from 'hooks/useStores';

import AddBotModal from './AddBotModal';
import { botApi, API_ROUTES } from '_app/api';
import { observer } from 'mobx-react';
import BotDetailsModal from './BotDetailsModal';

const BotsPage = () => {
  const [isOpen, setIsOpen] = useState(false);

  const [details, setDetails] = useState(null);

  const {
    botsStore: { data, fetchData, meta, isLoading, errors },
  } = useStores();

  useEffect(() => {
    fetchData();
  }, []);

  const columns = useMemo(
    () => [
      {
        Header: 'name',
        accessor: 'name',
      },
      {
        Header: 'Room Id',
        accessor: 'roomId',
      },
      {
        Header: 'isBotFast',
        accessor: 'isBotFast',
      },
    ],
    []
  );

  const onGetDetails = async name => {
    const { data } = await botApi.get(API_ROUTES.bots.bot, {
      params: {
        name,
      },
    });

    setDetails(data);
  };

  const rowActions = [
    {
      label: 'Details',
      onClick: async ({ original }) => {
        onGetDetails(original.name);
      },
    },
    {
      label: 'Remove',
      onClick: async ({ original }) => {
        try {
          await botApi.delete(API_ROUTES.bots.remove, {
            params: {
              name: original.name,
            },
          });

          fetchData();
        } catch (error) {
          console.error(error);
        }
      },
    },
  ];

  const onRemoveAll = async () => {
    try {
      await botApi.delete(API_ROUTES.bots.removeAll);

      fetchData();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div>
      <Flex justifyContent="space-between" mb={8}>
        <Heading>Bots</Heading>
      </Flex>
      <Flex justifyContent="space-between" my={3}>
        <Button onClick={onRemoveAll} variant="solid" colorScheme="red">
          Remove all
        </Button>
        <Button
          onClick={() => setIsOpen(true)}
          variant="solid"
          colorScheme="green"
          minW="200px"
        >
          Add bot
        </Button>
      </Flex>

      <Box minH="200px">
        <Table
          {...{
            columns,
            data,
            rowActions,
            isLoading,
          }}
        />
      </Box>

      <Flex justifyContent="center">
        <Button onClick={() => fetchData()}>Refresh</Button>
      </Flex>

      <BotDetailsModal
        isOpen={!!details}
        onClose={() => setDetails(null)}
        data={details}
      />
      <AddBotModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </div>
  );
};

export default observer(BotsPage);
